import produce from "immer";

import { CandidateState } from "../candidateState";
import { CombinedCandidatesFeatureActionTypes } from "../combinedCandidatesFeatureActions";
import names from "./statusChangeActionTypes";

export const changeStatusReducer = (
    state: CandidateState,
    action: CombinedCandidatesFeatureActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case names.UPDATE_CANDIDATE_JOB_STATUS: {
                draft.ui.isCandidateLoading = true;
                break;
            }

            case names.UPDATE_CANDIDATE_JOB_STATUS_SUCCESS: {
                draft.data.candidate = action.payload.candidate;
                draft.ui.isCandidateLoading = false;
                draft.ui.error = undefined;
                break;
            }

            case names.UPDATE_CANDIDATE_JOB_STATUS_FAILURE: {
                draft.ui.isCandidateLoading = false;
                draft.ui.error = {
                    type: "loading",
                    apiError: action.payload.apiError,
                };
                break;
            }
            case names.HIRE_EDIT_FAILURE:
            case names.HIRE_CANDIDATE_JOB_STATUS_FAILURE: {
                draft.ui.isCandidateLoading = false;
                break;
            }

            case names.INTERVIEW_ADD_EDIT_FAILURE: {
                draft.ui.isCandidateLoading = false;
                break;
            }
        }
    });
